import React, { useState } from "react";
import toast from "react-hot-toast";
import BackgroundImage from "../../assets/images/login-img.png";
import { api } from "../../api";
import { FaMicrosoft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [isLoading, setIsLoading] = useState(false);

  const resolveAuthData = (response) => {
    if (response?.data?.token) return response.data;
    if (response?.token) return response;
    return null;
  };

  const handleMicrosoftLogin = async () => {
    setIsLoading(true);
    const mockFlag = (process.env.REACT_APP_USE_MOCK_AZURE || "").trim().toLowerCase();
    const useMockAzure = ["1", "true", "yes", "on"].includes(mockFlag);

    if (useMockAzure) {
      try {
        const payload = {
          id: "ffd93e87-8760-46b4-bdcf-78cef31f659f",
          displayName: "Kenneth Ajijola",
          email: "kenneth.ajijola@loremprojectteamgmail.onmicrosoft.com",
          userPrincipalName: "kenneth.ajijola@loremprojectteamgmail.onmicrosoft.com",
          businessPhones: [],
          mobilePhone: null,
          jobTitle: null,
          officeLocation: null,
          preferredLanguage: null,
          firstName: null,
          lastName: null,
        };

        const response = await api.mockAzureAuthCallback(payload);
        const authData = resolveAuthData(response);

        if (!authData?.token) {
          throw new Error("Mock auth did not return a token.");
        }

        login(authData);
        navigate("/participant/dashboard", { replace: true });
      } catch (error) {
        toast.error(error?.response?.data?.message || error?.message || "Mock login failed.");
        setIsLoading(false);
      }
      return;
    }

    const baseUrl = process.env.REACT_APP_BASE_URL || "https://access-lms-be.loremexcellentiam.com/api";
    window.location.href = `${baseUrl}/auth/azure`;
  };

  return (
    <div className={`min-h-screen md:flex`}>
      <div className=" flex justify-center items-center bg-[#0A3059]  w-1/2">
        <img src={BackgroundImage} alt="login" className="h-[450px] w-[350px] border border-white p-4 rounded-[40px]" />
      </div>
      <div className="grid md:w-1/2 place-content-center bg-white  h-screen p-8">
        <div className="max-w-md w-full space-y-8 text-center">
          <div>
            <h2 className="mt-6 text-3xl font-extrabold text-gray-900">Welcome to Access LMS</h2>
            <p className="mt-2 text-sm text-gray-600">Please sign in with your corporate account</p>
          </div>
          <button
            onClick={handleMicrosoftLogin}
            disabled={isLoading}
            className="w-full flex justify-center items-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#0A3059] hover:bg-[#072445] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#0A3059] disabled:opacity-50 transition-colors"
          >
            {isLoading ? (
              <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            ) : (
              <FaMicrosoft className="mr-2 h-5 w-5" />
            )}
            {isLoading ? "Connecting..." : "Sign in with Microsoft"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;
